import i18next from 'i18next';

i18next.init({ resources: {}, fallbackLng: 'es', interpolation: { escapeValue: false } });

export default i18next;